<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div v-if="status_password ==='tidak_ada'" class="text-center remove-padding flex-1 font-weight-600">
                        Buat Kata Sandi
                    </div>
                    <div v-else class="text-center remove-padding flex-1 font-weight-600">
                        Ubah Kata Sandi
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 mar-top-60">
                    <div class="font-16 line-height-25 letter-space-002 color-0000 mar-bottom-16">Masukkan kata sandi baru untuk login melalui email <b>{{email_owner}}</b>.</div>
                    <div>
                        <div>
                            <label class="require color-6f7 font-14 mar-bot-4" for="newpass">Kata Sandi Baru</label>
                            <input type="password" id="newpass" class="form-control inputs" placeholder="" v-model="password" @keyup="inputpass1" v-on:keyup="listenCapslock($event, 'newpass')">
                            <span toggle="#password-field1" id="password-field1" v-on:click="changeViewPass1"
                                  class="fa fa-eye field-icon toggle-password"></span>
                            <div class="font-12 color-6f7 mar-top-5 line-height-18 letter-space-002">Minimal 8 karakter dengan kombinasi huruf dan angka</div>
	                        <ErrorMessage class="error" label="Password" :validation="$v.password"></ErrorMessage>
                        </div>
                        <div class="mar-top-16">
                            <label class="require color-6f7 font-14 mar-bot-4" for="confirmpass">Ulangi Kata Sandi Baru</label>
                            <input type="password" id="confirmpass" class="form-control inputs" placeholder="" v-model="confirm_password" @keyup="inputpass" v-on:keyup="listenCapslock($event, 'confirmpass')">
                            <span toggle="#password-field2" id="password-field2" v-on:click="changeViewPass"
                                  class="fa fa-eye field-icon toggle-password"></span>
	                        <ErrorMessage class="error" label="Password" :validation="$v.confirm_password"></ErrorMessage>
                        </div>
                    </div>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" id="btnbuatsandi" @click="createpass">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
                        <span id="textBtnbuatsandi">Simpan Kata Sandi</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, sameAs, required} from "vuelidate/lib/validators";

    export default {
        name: "CreatePassword",
	    components: { ErrorMessage },
        data(){
            return{
                owner:{},
                email_owner:'',
                password:'',
                confirm_password:'',
                isClicked:false,
                status_password:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    password: {
		    	required,
			    minLength: minLength(8),
		    },
		    confirm_password: {
		    	required,
			    minLength: minLength(8),
			    sameAsPassword: sameAs("password"),
		    }
	    },
        mounted() {
            this.getpasswordowner()
            this.getdetailowner()
        },
        methods:{
            back(){
                this.$router.push('/loginowneremail')
            },

            next(){
                this.$router.push('/successchangepassword')
            },

            changeViewPass1(event) {
                if ($('#newpass').attr("type") == "password") {
                    $('#password-field1').removeClass('fa fa-eye');
                    $('#password-field1').addClass('fa fa-eye fa-eye-slash');
                    $('#newpass').attr("type", "text");
                } else {
                    $('#password-field1').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field1').addClass('fa fa-eye');
                    $('#newpass').attr("type", "password");
                }
            },

            changeViewPass(event) {
                if ($('#confirmpass').attr("type") == "password") {
                    $('#password-field2').removeClass('fa fa-eye');
                    $('#password-field2').addClass('fa fa-eye fa-eye-slash');
                    $('#confirmpass').attr("type", "text");
                } else {
                    $('#password-field2').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field2').addClass('fa fa-eye');
                    $('#confirmpass').attr("type", "password");
                }
            },

            inputpass1(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.password = number;
                this.cekValidatepass()
                this.combinationpass1()
            },

            inputpass(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.confirm_password = number;
                this.cekValidatepass()
                this.combinationpass1()
            },

            cekValidatepass() {
                var passData = this.password;
                var confirm = this.confirm_password
                var lenPass = passData.length;
                if (lenPass >= 8 && confirm.length >=8) {
                    // $('#btnbuatsandi').prop('disabled', false);
                } else {
                    // $('#btnbuatsandi').prop('disabled', true);
                }
            },

            matchpassword(){
                var matchpass = this.password;
                if (matchpass === this.confirm_password && matchpass !== ''){
                    // $('#btnbuatsandi').prop('disabled', false);
                    this.createpass()
                }
                else {
                	this.$toast.error(res.data.msg)
                }
            },


            combinationpass1(){
                if(this.password !== '' && this.confirm_password !== '') {
                    var numeric = /[0-9]/;
                    var alphabeth = /[A-Za-z]/;
                    if(!numeric.test(this.password && this.confirm_password) || !alphabeth.test(this.password && this.confirm_password)) {
                        // $('#btnbuatsandi').prop('disabled', true);
                        return true;
                    }else{
                        // $('#btnbuatsandi').prop('disabled', false);
	                    return false;
                    }
                }else {
                    // $('#btnNextUsername').prop('disabled', false);
                    return false
                }

            },
	
	        errorValidation() {
		        this.$v.password.$touch()
		        this.$v.confirm_password.$touch()
		        return this.$v.password.$invalid || this.$v.confirm_password.$invalid
	        },
            async createpass(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
            	if (this.combinationpass1()) {
            		this.$toast.error("Password harus mengandung kombinasi huruh dan angka")
		            return
	            }
                this.isClicked = true;
                $('#textBtnbuatsandi').hide()
                $('#btnbuatsandi').prop('disabled', true);
                try {
                    const updatepass = new FormData;
                    updatepass.append('katasandi_fix', this.confirm_password);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_kata_sandi_owner', updatepass,this.requestHeaders)
                    if(res.data.status===true){
                        this.next()
                    }else{
                    	this.$toast.error(res.data.msg)
                        this.isClicked = false;
                        $('#textBtnbuatsandi').show()
                        $('#btnbuatsandi').prop('disabled', false);
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnbuatsandi').show()
	                $('#btnbuatsandi').prop('disabled', false);
                }
            },

            async getpasswordowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/owner/cek_password_owner',  this.requestHeaders);
                    this.status_password = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataownerpass = res.data.data
                        this.status_password = dataownerpass.status_pass_owner;
                    }else{

                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClickedloader = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },

            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
                    this.owner = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
                        this.email_owner = dataowner.email
                    }else{
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClickedloader = false
                }
            },
        }
    }
</script>

<style scoped>

</style>